import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState: {
  consumer: any
} = { consumer: {} }

const consumerFeatureFlag = createSlice({
  name: 'cieFeatureFlag',
  initialState,
  reducers: {
    setCieFeatureFlags(state, action: PayloadAction<any>) {
      state.consumer = action.payload
      return state
    },
  },
})

export const { setCieFeatureFlags } = consumerFeatureFlag.actions

export default consumerFeatureFlag.reducer
